export default __webpack_public_path__ + "static/media/undo.5a701e47.svg";